{
  "fr": {
    "common": {
      "search": "Recherche",
      "selected": "Selectionnés"
    }
  }
}
